
import GlobalConfig from "@/GlobalConfig";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ResultActualizacionDatos extends Vue{
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;

    public mounted(){


    }

	verify(){
		this.$router.push("actualizacion-de-datos");
	}
        generateCertify(){
        this.$router.push("certificado-beneficios");
    }

	
	returnHome(){
		window.location.href = GlobalConfig.PORTAL_BASE_URL
	}

}
